import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full pt-8 pb-12 px-4 flex flex-col items-center text-center overflow-hidden" data-id="element-144">
      {/* Background Glow */}
      <div className="absolute inset-0 hero-glow pointer-events-none" data-id="element-145" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="relative z-10 max-w-4xl mx-auto flex flex-col items-center" data-id="element-146">
        <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight leading-tight mb-2" data-id="element-147">
          <span className="text-text-main block text-[40px]" data-id="element-148">
            Todo tu contenido del mes.
          </span>
          <span className="text-primary block mt-2 text-[40px]" data-id="element-149">
            Listo. Desde hoy.
          </span>
        </h1>

        <div className="mt-8 mb-6 relative w-full max-w-2xl" data-id="element-150">
          {/* Subtle purple glow behind mockup */}
          <div className="absolute inset-0 bg-primary/20 blur-[100px] rounded-full" data-id="element-151" />
          <img src="https://cdn.magicpatterns.com/uploads/5ZJgZ6YYdmKDwQftKr5nC6/mockup_sf.png" alt="Kit Pack Creá Reels y Facturá Desde 0 Mockup" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-152" />
        </div>

        <h2 className="md:text-3xl font-bold text-primary mb-3 text-[20px]" data-id="element-153">
          KIT PACK — CREÁ REELS Y FACTURÁ DESDE 0
        </h2>

        <p className="md:text-2xl font-semibold text-text-main mb-3 text-[16px]" data-id="element-154">
          Hooks + Guiones + Reels Listos para Vender
        </p>

        <p className="text-lg text-text-muted mb-3 max-w-2xl" data-id="element-155">
          El sistema N°1 para emprendedores de e-commerce
        </p>

        <p className="text-base md:text-lg text-text-main mb-6 max-w-3xl font-medium" data-id="element-156">
          Sin improvisar. Sin no saber qué publicar. Sin perder ventas por falta
          de contenido.
        </p>

        <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-157">
          {['📄 100% PDF', '⚡ Acceso en 5 min', '📚 Cualquier nicho', '🛒 Listo para usar hoy'].map((pill, i) => <span key={i} className="px-4 py-2 rounded-full bg-alt border border-primary/30 text-sm font-medium text-text-main" data-id="element-158">
              {pill}
            </span>)}
        </div>

        <motion.a href="#plan-19990" whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="btn-glow bg-cta text-base font-bold text-xl md:text-2xl px-8 py-5 rounded-full uppercase tracking-wide w-full md:w-auto max-w-md mx-auto flex items-center justify-center gap-3" data-id="element-159">
          💥 QUIERO MI KIT PACK AHORA
        </motion.a>

        <div className="flex flex-wrap justify-center gap-6 mt-6 text-sm text-text-muted" data-id="element-160">
          <span className="flex items-center gap-2" data-id="element-161">
            <Shield size={16} data-id="element-162" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2" data-id="element-163">
            <Lock size={16} data-id="element-164" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-165">
            <CreditCard size={16} data-id="element-166" /> Mercado Pago
          </span>
        </div>
      </motion.div>
    </section>;
}